import React from 'react';
import { WebsiteDesignProps } from './types';
import { Shield, Lock, Award, Building2 } from 'lucide-react';
import { Button } from "@/components/ui/button";

const CorporateTrust: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Foundation Collegiate";

    return (
        <div className="bg-slate-50 text-slate-800 font-sans min-h-screen">
             <div className="bg-blue-900 text-white py-2 px-8 text-right text-sm">
                 <span className="opacity-80">Alumni Portal</span> <span className="mx-2">|</span> <span className="opacity-80">Staff Intranet</span>
             </div>
             
             <header className="bg-white shadow-sm border-b border-slate-200 sticky top-0 z-50">
                 <div className="container mx-auto px-8 py-4 flex justify-between items-center">
                     <div className="flex items-center gap-3">
                         <div className="p-2 bg-blue-800 rounded text-white">
                             <Building2 size={24} />
                         </div>
                         <h1 className="text-2xl font-bold text-blue-900 tracking-tight">{schoolName}</h1>
                     </div>
                     
                     <div className="hidden md:flex gap-8 font-semibold text-slate-600">
                         <a href="#" className="hover:text-blue-800">About Us</a>
                         <a href="#" className="hover:text-blue-800">Academics</a>
                         <a href="#" className="hover:text-blue-800">Admissions</a>
                         <a href="#" className="hover:text-blue-800">News</a>
                     </div>
                     
                     <Button className="bg-blue-800 hover:bg-blue-900 shadow-md font-semibold">Contact Us</Button>
                 </div>
             </header>

             <section className="bg-blue-900 text-white py-24 relative overflow-hidden">
                 <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1497215842964-222b4bef97ed?q=80&w=2070&auto=format&fit=crop')] bg-cover bg-center opacity-10 mix-blend-overlay"></div>
                 <div className="container mx-auto px-8 relative z-10 grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                     <div>
                         <h2 className="text-4xl md:text-5xl font-bold mb-6 leading-tight">
                             Building a Solid Foundation for Life.
                         </h2>
                         <p className="text-blue-100 text-lg mb-8 max-w-lg leading-relaxed">
                             We provide a safe, structured, and challenging environment where students achieve academic excellence and develop strong moral character.
                         </p>
                         <div className="flex gap-4">
                             <Button className="bg-yellow-500 hover:bg-yellow-600 text-blue-900 font-bold px-8 h-12">Apply Today</Button>
                             <Button variant="outline" className="text-white border-white hover:bg-white/10 px-8 h-12">Download Prospectus</Button>
                         </div>
                     </div>
                     <div className="bg-white p-2 rounded-lg shadow-2xl transform rotate-1">
                         <img src="https://images.unsplash.com/photo-1524178232363-1fb2b075b655?q=80&w=2070&auto=format&fit=crop" className="rounded w-full" alt="Students" />
                     </div>
                 </div>
             </section>

             <section className="py-20 bg-white">
                 <div className="container mx-auto px-8">
                     <div className="text-center mb-16">
                         <h2 className="text-3xl font-bold text-blue-900 mb-4">Why Choose {schoolName}?</h2>
                         <p className="text-slate-600 max-w-2xl mx-auto">We are committed to the highest standards of education and safety.</p>
                     </div>

                     <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                         <div className="p-8 border border-slate-200 rounded-xl hover:shadow-lg transition-shadow bg-slate-50">
                             <Shield className="w-12 h-12 text-blue-800 mb-6" />
                             <h3 className="text-xl font-bold text-blue-900 mb-4">Safe Environment</h3>
                             <p className="text-slate-600">State-of-the-art security and supportive pastoral care ensure every child feels secure.</p>
                         </div>
                         <div className="p-8 border border-slate-200 rounded-xl hover:shadow-lg transition-shadow bg-slate-50">
                             <Award className="w-12 h-12 text-blue-800 mb-6" />
                             <h3 className="text-xl font-bold text-blue-900 mb-4">Proven Results</h3>
                             <p className="text-slate-600">Consistently ranked in the top 10% for national exam results for the past decade.</p>
                         </div>
                         <div className="p-8 border border-slate-200 rounded-xl hover:shadow-lg transition-shadow bg-slate-50">
                             <Lock className="w-12 h-12 text-blue-800 mb-6" />
                             <h3 className="text-xl font-bold text-blue-900 mb-4">Data Privacy</h3>
                             <p className="text-slate-600">We take the privacy of our students and families seriously, with enterprise-grade data protection.</p>
                         </div>
                     </div>
                 </div>
             </section>
        </div>
    );
};

export default CorporateTrust;
